import { faFacebook, faInstagram, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { Icon } from '@/components/ui';
import useHeaderContent from '@/hooks/use-header-content';
import { useResolveThemeColor } from '@/hooks/use-resolve-theme-color';

const ContactBanner = () => {
  const resolveThemeColor = useResolveThemeColor();
  const headerContent = useHeaderContent();
  if (!headerContent.contactBanner) {
    return null;
  }

  const textColor = resolveThemeColor(headerContent.contactBannerTextColor ?? 'content1');
  const background = resolveThemeColor(headerContent.contactBannerBackground ?? 'foreground');
  const socials = headerContent.contactBannerSocialLinks ?? {};
  const socialLinks = [
    { key: 'youtube', href: socials.youtube, icon: faYoutube, label: 'YouTube' },
    { key: 'instagram', href: socials.instagram, icon: faInstagram, label: 'Instagram' },
    { key: 'facebook', href: socials.facebook, icon: faFacebook, label: 'Facebook' },
    { key: 'tiktok', href: socials.tiktok, icon: faTiktok, label: 'TikTok' },
  ].filter(item => Boolean(item.href));

  const phone = headerContent.contactBanner.phone;
  const email = headerContent.contactBanner.email;

  return (
    <div className="flex min-h-10 w-full items-center @lg:h-10" style={{ background }}>
      <div className="container mx-auto flex min-h-10 w-full items-center justify-between gap-2 px-3 py-1.5 @lg:h-full @lg:gap-6 @lg:px-5 @lg:py-0">
        <div className="flex items-center gap-4 @lg:gap-6">
          <a
            href={`tel:${phone}`}
            className="inline-flex min-h-10 min-w-10 items-center justify-center gap-2 rounded-md @lg:min-h-0 @lg:min-w-0 @lg:text-sm @lg:font-semibold"
            style={{ color: textColor }}
            aria-label={`Phone ${phone}`}
          >
            <Icon
              icon={faPhone}
              className="text-lg @lg:text-base"
              size="lg"
              style={{ color: textColor }}
            />
            <span className="hidden truncate @lg:inline">{phone}</span>
          </a>
          <a
            href={`mailto:${email}`}
            className="inline-flex min-h-10 min-w-10 items-center justify-center gap-2 rounded-md @lg:min-h-0 @lg:min-w-0 @lg:text-sm @lg:font-semibold"
            style={{ color: textColor }}
            aria-label={`Email ${email}`}
          >
            <Icon
              icon={faEnvelope}
              className="text-lg @lg:text-base"
              size="lg"
              style={{ color: textColor }}
            />
            <span className="hidden truncate @lg:inline">{email}</span>
          </a>
        </div>
        <div className="flex shrink-0 items-center gap-3 @lg:gap-4">
          {socialLinks.map(social => (
            <a
              key={social.key}
              href={social.href}
              target="_blank"
              rel="noreferrer"
              aria-label={social.label}
              className="inline-flex"
            >
              <Icon
                icon={social.icon}
                className="cursor-pointer"
                size="lg"
                style={{ color: textColor }}
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactBanner;
